import { render, staticRenderFns } from "./editor-layers.vue?vue&type=template&id=4ed4cac2&"
import script from "./editor-layers.vue?vue&type=script&lang=js&"
export * from "./editor-layers.vue?vue&type=script&lang=js&"
import style0 from "./editor-layers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports